module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-show-container",
    style: ({
      width: _vm.size.width + 'px',
      height: _vm.size.height + 'px'
    }),
    on: {
      "click": _vm.increment
    }
  }, [_c('div', {
    staticClass: "swiper-container",
    style: ({
      width: _vm.container_width,
      transform: 'translate3d' + _vm.translate3d,
      transitionDuration: _vm.duration
    }),
    on: {
      "transitionend": _vm.transitionend
    }
  }, _vm._l((_vm.compouted_images), function(item, index) {
    return _c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      style: ({
        width: _vm.size.width + 'px',
        height: _vm.size.height + 'px'
      }),
      attrs: {
        "src": item.src
      }
    })])
  })), _c('div', {
    staticClass: "carousel-control"
  }, [_c('div', {
    staticClass: "pre_and_next iconfont"
  }, [_c('li', {
    staticClass: "pre-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.turnToPre($event)
      }
    }
  })]), _c('li', {
    staticClass: "next-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.turnToNext($event)
      }
    }
  })])]), _c('ul', {
    staticClass: "pagination"
  }, _vm._l((_vm.images), function(pagItem, pagInex) {
    return _c('li', {
      staticClass: "pagination-item",
      class: {
        'selected': pagInex === _vm.cur_index
      },
      on: {
        "click": function($event) {
          _vm.selectItem(pagInex)
        }
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af5fc2b6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = 16
// module chunks = 0